import { get, useFormContext } from 'react-hook-form';
import { Input } from '@repo/ui/Input';
import { InputField } from '@repo/ui/Input/InputField';
import { InputGroup } from '@repo/ui/Input/InputGroup';
import { InputLabel } from '@repo/ui/Input/InputLabel';
import { InputRoot } from '@repo/ui/Input/InputRoot';
import { Text } from '../../Language/Language';
import s from './SignatureInput.module.css';
import { Flex } from '@repo/ui/Flex';

export const SignatureInput = () => {
  const { register, formState } = useFormContext();
  const { errors } = formState;

  return (
    <Flex
      className={s.container}
      direction="column"
      padding={['px-24', 'md:px-0']}
    >
      <div className={s.instructions}>
        <div className={s.instructionsHeader}>
          <Text langKey="Global.review.attestation.instructions.header" />
        </div>
        <Text langKey="Global.review.attestation.instructions.description" />
      </div>
      <label htmlFor="signature.signature" className={s.signatureLabel}>
        <Text langKey="Global.review.signature.label" />
      </label>
      <InputRoot width="full" className={s.inputSpacing}>
        <InputGroup>
          <InputField>
            <InputLabel htmlFor="signature.signature">
              <Text langKey="Global.review.signature.placeholder" />
            </InputLabel>
            <Input
              id="signature.signature"
              {...register('signature.signature')}
            />
          </InputField>
        </InputGroup>
      </InputRoot>
      {errors?.signature && 'signature' in errors.signature && (
        <div className={s.error}>
          {get(errors.signature, 'signature')?.message}
        </div>
      )}
    </Flex>
  );
};
